import {ValueObject} from '@s-ui/domain'

/**
 * @implements ValueObject
 * Converts tag from suggestions term to url format.
 */
export default class FormattedNewsTagValueObject extends ValueObject {
  /**
   * @constructor
   */
  constructor({config, tag}) {
    super({config, tag})
    this._tag = tag
    this._brands = config.get('editorial').SPECIAL_BRANDS
    this._NEED_SPECIAL_FORMAT_TAG_TO_URL = config.get('editorial').NEED_SPECIAL_FORMAT_TAG_TO_URL
  }

  static underScoreTwoSpacedWords(words) {
    words = words.replace(/\s+$/, '-')
    return words.split(' ').join('_')
  }

  _cleanTag() {
    const tag = this._tag
      .toLowerCase()
      .replace(/[^a-z0-9À-ú]+$/g, '') // removing any non character at final
      .replace(/\s+/g, ' ') // removing any extra space between words
    return tag
  }

  _getFixedNameBrand() {
    return this._brands.reduce(
      (str, brand) => str.replace(brand, FormattedNewsTagValueObject.underScoreTwoSpacedWords),
      this._cleanTag()
    )
  }

  _formatTagToUrl() {
    const pattern = /([a-z_-]{3,} [a-z0-9]{1} )|([a-z_-]{3,} [a-z0-9]{1})$/g
    const tag = this._getFixedNameBrand()
    const tagFormated = tag.replace(/-+/g, '_')
    const isPatternMatched = pattern.test(tagFormated)
    return isPatternMatched && this._NEED_SPECIAL_FORMAT_TAG_TO_URL
      ? tagFormated.replace(pattern, FormattedNewsTagValueObject.underScoreTwoSpacedWords).replace(/ /g, '-')
      : tagFormated.replace(/ /g, '-')
  }

  toString() {
    return this._formatTagToUrl()
  }

  toJSON() {
    return this.toString()
  }
}
